import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../Config/Config";

const getErrorCodes = async (id) => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No User details found in localStorage");

  const user = JSON.parse(userDetails);
  const response = await axios.get(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=getErrorCodesForTestSuite&companyid=${user.companyid}&testSuiteResultId=${id}`,
  );

  return response.data;
};

const useGetErrorCodesQuery = (id, options) => {
  return useQuery({
    queryKey: ["errorCodes", id],
    queryFn: () => getErrorCodes(id),
    enabled: options.enabled,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...options,
  });
};

export default useGetErrorCodesQuery;
